import React from 'react'
import { Box } from '@mui/material'
import BasicEmploymentDetails from '../components/BasicEmploymentDetails'
import JobInformation from '../components/JobInformation'
import { useQuery } from 'react-query'
import { getEmploymentData } from 'services/api/modules/staff-management/staffManagementDashboard'
import { profileDepartments } from 'services/api/dropdown'

const EmploymentTab = ({ windowCheckEmployeeFile, employeeID }) => {
  const {
    // isLoading,
    // error,
    data: employment,
  } = useQuery(['employeeEmploymentData', employeeID], async () => {
    window.scrollTo(0, 0)
    const { data } = await getEmploymentData(employeeID)
    return data
  })

  const { data: departmentList } = useQuery('employeeProfileDepartmentList', async () => {
    const { data } = await profileDepartments()
    return data
  })

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, py: 2 }}>
      <Box sx={{ border: 1, borderRadius: '4.5px', borderColor: 'gray-line.main' }}>
        <BasicEmploymentDetails
          data={employment}
          employeeID={employeeID}
          windowCheckEmployeeFile={windowCheckEmployeeFile}
        />
      </Box>

      <Box sx={{ border: 1, borderRadius: '4.5px', borderColor: 'gray-line.main' }}>
        <JobInformation
          data={employment}
          employeeID={employeeID}
          departmentList={departmentList}
          windowCheckEmployeeFile={windowCheckEmployeeFile}
        />
      </Box>
    </Box>
  )
}

export default EmploymentTab
